import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import {
  ToggleButton,
  ToggleButtonProps,
  ToggleButtonValue,
} from "component-library";

export type ControlledToggleButtonProps<
  F extends FieldValues,
  N extends FieldPath<F>,
  Value extends ToggleButtonValue,
> = {
  control: Control<F>;
  name: N;
  options: ToggleButtonProps<Value>["options"];
  rules?: RegisterOptions<F, N>;
  errorTranslation: string;
};

export const ControlledToggleButton = <
  Value extends ToggleButtonValue,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: ControlledToggleButtonProps<TFieldValues, TName, Value>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ field, fieldState }) => (
        <ToggleButton
          value={field.value}
          onChange={field.onChange}
          options={props.options}
          hasError={fieldState.error !== undefined}
          errorTranslation={props.errorTranslation}
        />
      )}
    />
  );
};
